import { Bank } from '../../models';

export const bankMock: Bank[] = [{ name: 'MocketBNK' }];
